// src/context/DataContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLiveRates } from '../hooks/useLiveRates';
import { PRODUCTS_DATA } from '../config/constants';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [products] = useState(PRODUCTS_DATA); // Removed setProducts since it wasn't used
  const [loading, setLoading] = useState(false);
  
  const { 
    rates, 
    isConnected, 
    error, 
    lastUpdate,
    usingFallback,
    reconnect 
  } = useLiveRates();

  useEffect(() => {
    setLoading(false);
  }, []);

  const value = {
    rates,
    products,
    loading,
    isConnected,
    error,
    lastUpdate,
    usingFallback,
    reconnect,
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};